/* istanbul ignore file */
import { defineMessages } from 'react-intl';

export const en = defineMessages({
  title: {
    id: `seo_blue_beetle_title_en`,
  },
  description: {
    id: `seo_blue_beetle_description_en`,
  },
});

export const en_us = defineMessages({
  title: {
    id: `seo_blue_beetle_title_en_us`,
  },
  description: {
    id: `seo_blue_beetle_description_en_us`,
  },
});

export const es = defineMessages({
  title: {
    id: `seo_blue_beetle_title_es`,
  },
  description: {
    id: `seo_blue_beetle_description_es`,
  },
});

export const es_mx = defineMessages({
  title: {
    id: `seo_blue_beetle_title_es_mx`,
  },
  description: {
    id: `seo_blue_beetle_description_es_mx`,
  },
});
